import React, { Component } from 'react';
import { Form, Input, Col, Row, Avatar, InputNumber, message, Tooltip, Button, Tabs } from 'antd';
import ModalDom from '../../../../../components/Modal';
import { CustomRow, CustomCol } from '../../../../../components/Custom';
import { post, config, postFrom } from '../../../../../axios';
import Cookies from "js-cookie";

import Iconweixin from '../../../../../style/imgs/icon-weixin.png';
import Iconeryaosu from '../../../../../style/imgs/icon-eryaosu.png';
import Iconrenlian from '../../../../../style/imgs/icon-renlian.png';
import Iconshiming from '../../../../../style/imgs/icon-shiming.png';
import Iconzhengjian from '../../../../../style/imgs/icon-zhengjian.png';


import BasicMessage from './BasicMessage/index'; //基本信息
import BillMessage from './BillMessage/index';  //账单信息
import ReceiveWater from './ReceiveWater/index'; //收付流水
import RetreatMessage from './RetreatMessage/index'; //退租信息
import SigningMessage from './SigningMessage/index'; //签约信息
import APILog from './APiLog/index' // 签约信息
import "./index.less"


class Details extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            headerInputWidth: "185px",
            data: {},
            customerType: 1, //租客类别 1：企业， 2：个人
            rentContractId: '', //租赁合同id
            headerIsShow: true,
            userInfo: {}

        }
    }

    componentDidMount() {
        this.props.onRef(this)
        const userInfo = JSON.parse(Cookies.get('loginData') || "{}")
        console.log(userInfo.merchantId)
        this.setState({ userInfo })
    }

    initUserType = (customerType) => { //初始化用户类型
        this.setState({ customerType });
    }

    handleCancel = () => { //关闭页面
        this.props.handleCancel();
        this.setState({ customerType: 0, data: {}, loading: false });
    }

    initPack() {

    }

    loadPack = ({ id }) => {
        this.setState({ loading: true, rentContractId: id });
        postFrom(
            {
                url: config.API_rentcontract_getRentContractById,
                data: { rentContractId: id }
            }
        ).then(res => {
            this.setState({ loading: false, customerType: res.customerType, data: res });
        }).catch(err => {
            message.error(err.message || '获取详情失败');
            this.setState({ loading: false });
        });
    }

    handleOk = () => {
        this.props.form.validateFieldsAndScroll((error, values) => {
            if (!error) { }

        })
    }

    onChange = (key) => {
        if (parseInt(key) !== 1)
            this.setState({ headerIsShow: false })
        else
            this.setState({ headerIsShow: true })
    }

    handleSave = (value) => {
        post({
            url: config.API_rentcontract_editRentContractMsg,
            data: Object.assign({}, value, { id: this.state.data.customerId })
        }).then(res => {
            message.success('保存成功');
        }).catch(err => {
            message.error(err.message || '保存失败');
            this.setState({ loading: false });
        })
    }

    render() {
        const { TabPane } = Tabs;
        let { visible, form: { getFieldDecorator, setFieldsValue } } = this.props;
        let {
            loading,
            data,
            headerInputWidth,
            customerType,
            headerIsShow,
        } = this.state;

        return (
            <div>
                <ModalDom
                    title={"合同详情"}
                    visible={visible}
                    loading={loading}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                    footer={
                        <div>
                            {/* <Button type="primary" loading={loading}>打印</Button> */}
                            <Button onClick={this.handleCancel}>关闭</Button>
                        </div>
                    }
                >
                    <div className="custom" style={{ maxWidth: '1280px' }}>
                        <div style={headerIsShow ? styles.block : styles.none}>
                            <Form
                                labelCol={{ span: 0 }}
                                wrapperCol={{ span: 24 }}
                            >
                                <Row>
                                    <Col>
                                        <div className="sign_container">
                                            <div className="sign_avatar"><Avatar size={60} src={data.weixinLogo ? data.weixinLogo : ""} icon={"user"} /></div>
                                            {
                                                customerType === 2 ?
                                                    <div className="sign_input_box">
                                                        <Row>
                                                            <Col>
                                                                <CustomRow divider>
                                                                    <CustomCol label="姓名" required={false} >
                                                                        <Tooltip placement="bottomLeft" title={"该选项仅供浏览"} trigger="click">
                                                                            <span className="not-edit" style={{ width: headerInputWidth }}>{`${data.customerName}`}</span>
                                                                        </Tooltip>
                                                                        {/* {getFieldDecorator('customerName', {
                                                            rules: [{
                                                                required: false, message: '请输入',
                                                            }],
                                                            initialValue: data.customerName
                                                        })(
                                                            <Input
                                                                placeholder={'请输入'}
                                                                disabled= {true}
                                                                autoComplete={'off'}
                                                                style={{ width: headerInputWidth }}
                                                            />
                                                        )} */}
                                                                    </CustomCol>
                                                                    <CustomCol label="手机号码" subfix={<div style={{ textDecoration: "underline", cursor: "pointer" }}>保存</div>} savefn={() => this.handleSave({ phone: data.customerPhone })} >
                                                                        {getFieldDecorator('customerPhone', {
                                                                            rules: [{
                                                                                required: true, message: '请输入',
                                                                            }],
                                                                            initialValue: data.customerPhone
                                                                        })(
                                                                            <Input
                                                                                placeholder={'请输入'}
                                                                                autoComplete={'off'}
                                                                                style={{ width: headerInputWidth }}
                                                                                onChange={(e) => {
                                                                                    const {value} = e.target
                                                                                    setFieldsValue({ customerPhone: value });
                                                                                    data.customerPhone = value;
                                                                                }}
                                                                            />
                                                                        )}
                                                                    </CustomCol>
                                                                </CustomRow>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col>
                                                                <CustomRow divider>
                                                                    <CustomCol required={false} label="联系人" subfix={<div style={{ textDecoration: "underline", cursor: "pointer" }}>保存</div>} savefn={() => this.handleSave({ linkmanName: data.linkmanName })}>
                                                                        {getFieldDecorator('linkmanName', {
                                                                            // rules: [{
                                                                            //     required: true, message: '请输入',
                                                                            // }],
                                                                            initialValue: data.linkmanName
                                                                        })(
                                                                            <Input
                                                                                placeholder={'请输入'}
                                                                                autoComplete={'off'}
                                                                                style={{ width: headerInputWidth }}
                                                                                onChange={(e) => {
                                                                                    data.linkmanName = e.target.value;
                                                                                }}
                                                                            />
                                                                        )}
                                                                    </CustomCol>
                                                                    <CustomCol required={false} label="手机号码" subfix={<div style={{ textDecoration: "underline", cursor: "pointer" }}>保存</div>} savefn={() => this.handleSave({ linkmanPhone: data.linkmanPhone })}>
                                                                        {getFieldDecorator('linkmanPhone', {
                                                                            // rules: [{
                                                                            //     required: true, message: '请输入',
                                                                            // }],
                                                                            initialValue: data.linkmanPhone
                                                                        })(
                                                                            <Input
                                                                                placeholder={'请输入'}
                                                                                autoComplete={'off'}
                                                                                style={{ width: headerInputWidth }}
                                                                                onChange={(e) => {
                                                                                    const {value} = e.target
                                                                                    setFieldsValue({ linkmanPhone: value });
                                                                                    data.linkmanPhone = value;
                                                                                }}
                                                                            />
                                                                        )}
                                                                    </CustomCol>
                                                                </CustomRow>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                    :
                                                    <div className="sign_input_box">
                                                        <Row>
                                                            <Col>
                                                                <CustomRow divider>
                                                                    <CustomCol label="企业名称" >
                                                                        {getFieldDecorator('customerName', {
                                                                            rules: [{
                                                                                required: true, message: '请输入',
                                                                            }],
                                                                            initialValue: data.customerName
                                                                        })(
                                                                            <Input
                                                                                placeholder={'请输入'}
                                                                                disabled={true}
                                                                                autoComplete={'off'}
                                                                                style={{ width: "470px" }}
                                                                            />
                                                                        )}
                                                                    </CustomCol>
                                                                </CustomRow>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col>
                                                                <CustomRow divider>
                                                                    <CustomCol label="联系人" subfix={<div style={{ textDecoration: "underline", cursor: "pointer" }}>保存</div>}>
                                                                        {getFieldDecorator('linkmanName', {
                                                                            rules: [{
                                                                                required: true, message: '请输入',
                                                                            }],
                                                                            initialValue: data.linkmanName
                                                                        })(
                                                                            <Input
                                                                                placeholder={'请输入'}
                                                                                autoComplete={'off'}
                                                                                style={{ width: headerInputWidth }}
                                                                            />
                                                                        )}
                                                                    </CustomCol>
                                                                    <CustomCol label="手机号码" subfix={<div style={{ textDecoration: "underline", cursor: "pointer" }}>保存</div>}>
                                                                        {getFieldDecorator('linkmanPhone', {
                                                                            rules: [{
                                                                                required: true, message: '请输入',
                                                                            }],
                                                                            initialValue: data.linkmanPhone
                                                                        })(
                                                                            <InputNumber
                                                                                placeholder={'请输入'}
                                                                                autoComplete={'off'}
                                                                                style={{ width: headerInputWidth }}
                                                                            />
                                                                        )}
                                                                    </CustomCol>
                                                                </CustomRow>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                            }
                                            <div>
                                                {data.weixinNickname ? <Tooltip placement="bottomLeft" arrowPointAtCenter title={"已关联微信"}><Avatar size={30} src={Iconweixin} /></Tooltip> : null}
                                                {parseInt(data.realNameIdentified) ? <Tooltip placement="bottomLeft" arrowPointAtCenter title={"已实名"}><Avatar size={30} src={Iconshiming} /></Tooltip> : null}
                                                {parseInt(data.credentialIdentified) === 1 ? <Tooltip placement="bottomLeft" arrowPointAtCenter title={"证件已认证"}><Avatar size={30} src={Iconzhengjian} /></Tooltip> : null}
                                                {parseInt(data.realNameIdentified) === 1 ? <Tooltip placement="bottomLeft" arrowPointAtCenter title={"二要素已认证"}><Avatar size={30} src={Iconeryaosu} /></Tooltip> : null}
                                                {parseInt(data.faceDetected) === 1 ? <Tooltip placement="bottomLeft" arrowPointAtCenter title={"已人脸识别"}><Avatar size={30} src={Iconrenlian} /></Tooltip> : null}
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </Form>
                        </div>


                        <Tabs defaultActiveKey="1" type="line" onChange={this.onChange} >
                            <TabPane tab="签约信息" key="1">
                                <SigningMessage data={data} />
                            </TabPane>
                            <TabPane tab="退租信息" key="2">
                                <RetreatMessage id={this.state.rentContractId} />
                            </TabPane>
                            <TabPane tab="租客信息" key="3">
                                <BasicMessage id={this.state.rentContractId} />
                            </TabPane>
                            <TabPane tab="账单信息" key="4">
                                <BillMessage id={this.state.rentContractId} />
                            </TabPane>
                            <TabPane tab="收款流水" key="5">
                                <ReceiveWater id={this.state.rentContractId} />
                            </TabPane>
                            {
                              this.state.userInfo.merchantId > 0 ? null : (
                                <TabPane tab="签约日志" key="6" >
                                  <APILog id={this.state.rentContractId} />
                                </TabPane>
                              )
                            }
                            
                        </Tabs>
                    </div>
                </ModalDom>

            </div>

        )
    }
}

const styles = {
    none: {
        display: "none"
    },
    block: {
        display: "block"
    }
}

export default Form.create()(Details)


// WEBPACK FOOTER //
// ./src/page/RentContract/components/List/details/index.js